import { useMutation } from '@tanstack/react-query';
import { ListingMaterialOrigin, QuoteEntry, RFQBuyerModel } from '@steelbuy/ts-shared';
import axios from '../axios';

type CreateModel = CreateRFQModel | CreateRequestQuoteModel;

export type CreateRFQModel = {
    expiresAt: string;
    origin: ListingMaterialOrigin[];
    additionalInformation?: string;
    delivery: { month: number; year: number };
    quoteEntry: QuoteEntry[];
    draftId?: string;
};

export type CreateRequestQuoteModel = {
    additionalInformation?: string;
    quoteEntry: QuoteEntry[];
    draftId?: string;
};

const createRFQ = async (rfq: CreateModel) => {
    const { data } = await axios.post<RFQBuyerModel>('/api/buyer/quotes', rfq);
    return data;
};

export const useCreateRFQ = () =>
    useMutation({
        mutationFn: (rfq: CreateModel) => createRFQ(rfq),
    });
